import Vue from 'vue';
import VueRouter from 'vue-router';

import HistoryQuery from '../views/HistoryQuery';
import SearchHistoryView from '../views/SearchHistoryView';
import HistoryCAS from '../views/HistoryCAS';
import { HISTORY_PERMISSIONS_MAP } from '../constants';
import { find } from 'lodash';

Vue.use(VueRouter);
const tabDefaultPaths = [
    {
        tab: 'analytics',
        path: '/analytics/0/1'
    },
    {
        tab: 'discovery',
        path: '/discovery/0/1'
    },
    {
        tab: 'chemical',
        path: '/chemical/0/1'
    },
    {
        tab: 'cas',
        path: '/cas'
    },
];
const getDefaultPath = (history_permission)=>{
    let defaultPath = find(tabDefaultPaths, (item)=>{
        return history_permission[HISTORY_PERMISSIONS_MAP[item.tab]];
    });
    if (!defaultPath) {
        defaultPath = { path: '/login/0/1' };
    }
    return defaultPath;
};
const rootMap = [
    {
        path: '/',
        name: 'historyQuery',
        component: HistoryQuery,
        redirect: '/analytics/0/1',
        children: [
            {
                path: ':type/:tab/:page',
                name: 'historyQuerySearchHistoryView',
                component: SearchHistoryView,
                beforeEnter: (to, from, next) => {
                    const history_permission = window.zPREFACE.history_permission;
                    if (!history_permission[HISTORY_PERMISSIONS_MAP[to.params.type]]) {
                        if (
                            to.params.type === HISTORY_PERMISSIONS_MAP.discovery &&
                            (history_permission[HISTORY_PERMISSIONS_MAP[to.params.type]] 
                                || history_permission.eureka_insights)
                        ) {
                            next();
                        }else{
                            next(getDefaultPath(history_permission));
                        }
                    }
                    next();
                },
            },
            // TODO 同时兼容普通路由和微前端路由，普通路由使用params微前端使用meta传递参数，后续都改为微前端
            // TODO 同时兼容普通路由和微前端路由，普通路由使用params微前端使用meta传递参数，后续都改为微前端
            // TODO 同时兼容普通路由和微前端路由，普通路由使用params微前端使用meta传递参数，后续都改为微前端
            {
                path: 'cas',
                name: 'historyCASEntry',
                meta: {
                    type: 'cas',
                },
                component: HistoryCAS,
                beforeEnter: (to, from, next) => {
                    const history_permission = window.zPREFACE.history_permission;
                    if (!history_permission[HISTORY_PERMISSIONS_MAP[to.meta.type]]) {
                        next(getDefaultPath(history_permission));
                    } else {
                        next();
                    }
                },
            }
        ]
    }
];

export default new VueRouter({
    routes: rootMap
});
